<template>
  <DefaultLayout>
    <div slot="content">
      <div class="d-flex align-center py-3">
        <div class="title">Profile Items</div>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Search" hide-details dense></v-text-field>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" fab dark small color="green" @click="addProfileItem"><v-icon>add</v-icon></v-btn>
          </template>
          <span>Create Profile Item</span>
        </v-tooltip>
      </div>
      <v-divider></v-divider>
      <v-data-table :headers="profileItemsHeaders"
                    :loading="dataLoading"
                    :items="profileItems"
                    :search="search"
                    :footer-props="{
                      itemsPerPageOptions: [10, 20, 50, { text: 'All', value: -1 }],
                      showFirstLastPage: false,
                      prevIcon: 'fal fa-chevron-left',
                      nextIcon: 'fal fa-chevron-right',
                      itemsPerPageText: 'Items per page'
                    }"
                    :hide-default-footer="profileItems.length < 11">
        <template v-slot:top="{ pagination, options, updateOptions }">
          <v-data-footer 
            :pagination="pagination" 
            :options="options"
            :itemsPerPageOptions="[10, 20, 50, { text: 'All', value: -1 }]"
            :showFirstLastPage="false"
            prevIcon="fal fa-chevron-left"
            nextIcon="fal fa-chevron-right"
            @update:options="updateOptions"
            items-per-page-text="Items per page" />
        </template>
        <template v-slot:item.itemType="{ item }">{{ getItemType(item.itemType) }}</template>
        <template v-slot:item.id="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" text icon color="green" @click="editProfileItem(item)"><v-icon>edit</v-icon></v-btn>
            </template>
            <span>Edit Item</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-dialog v-model="dialog" scrollable width="500">
        <v-card>
          <v-card-title class="blue-grey white--text">{{ modalTitle }}</v-card-title>
          <v-card-text>
            <v-form ref="itemForm">
              <v-text-field v-model="name" label="Name" type="text" ref="name" :rules="[v => !!v || '']" hide-details></v-text-field>
              <v-text-field v-model="description" label="Description" type="text" ></v-text-field>
              <v-select dense :items="itemType" item-text="text" item-value="id" v-model="selectedItemType" label="Item Type"></v-select>
              <v-select v-if="selectedItemType == 1" dense :items="dataType" item-text="text" item-value="id" v-model="selectedDataType" label="Data Type"></v-select>
              <v-text-field v-model="ordinal" label="Ordinal" type="numeric" ></v-text-field>
              <template v-if="selectedItemType == 4">
                <div class="title mb-2">Sections</div>
                <div v-for="section in sections" :key="section.id" class="grey lighten-4 px-3 pb-3 mb-2">
                  <v-text-field v-model="section.name" label="Section Name" type="text" :ref="section.name" :rules="[v => !!v || '']"></v-text-field>
                  <v-row v-for="item in section.sectionItems" :key="item.id">
                    <v-col cols="12" sm="6" class="py-0"><v-select dense :items="dataType" item-text="text" item-value="id" v-model="item.dataType" label="Item Type"></v-select></v-col>
                    <v-col cols="12" sm="6" class="py-0"><v-text-field dense v-model="item.name" label="Name" type="text" :ref="item.name" :rules="[v => !!v || '']"></v-text-field></v-col>
                  </v-row>
                  <v-btn small tile dark depressed color="blue" @click="addItem(section)">Add Item</v-btn>
                </div>
                <v-btn small tile dark depressed color="blue" @click="addSection">Add Section</v-btn>
              </template>
              <v-select dense multiple :items="verificationProviders" item-text="name" item-value="id" v-model="selectedVerificationProviders" label="Verification providers"></v-select>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile text color="blue" @click="dialog = false">Close</v-btn>
            <v-btn tile dark depressed color="blue" @click="saveProfileItem">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </DefaultLayout>
</template>

<script>
import uuidv4 from 'uuid/v4';
import { GET_VERIFICATION_PROVIDERS, GET_PROFILE_ITEMS, ADD_PROFILE_ITEM } from '@/store/actions.type';
import DefaultLayout from '@/layouts/DefaultLayout';

export default {
  name: 'profile-items',
  components: {
    DefaultLayout,
  },
  data() {
    return {
      dataLoading: false,
      dialog: false,
      search: '',
      profileItemsHeaders: [
        { text: 'Name', value: 'name', align: 'left' },
        { text: 'Type', value: 'itemType', align: 'left' },
        { text: 'Description', value: 'description', align: 'left' },
        { text: 'Ordinal', value: 'ordinal', align: 'left' },
        { text: 'Actions', value: 'id', align: 'left', sortable: false },
      ],
      modalTitle: 'New Profile Item',
      profileItems: [],
      verificationProviders: [],
      id: '',
      name: '',
      description: '',
      ordinal: 0,
      itemType: [{ id: 1, text: 'Scalar'}, {id: 2, text: 'Scanned'}, {id: 3, text: 'Imported'}, {id: 4, text: 'Template'}, {id: 5, text: 'DocuSign'}, {id: 6, text: 'Agreement' }],
      selectedItemType: 1,
      selectedVerificationProviders: [],
      dataType: [{ id: 1, text: 'Text'}, { id:2, text: 'Numeric'}, { id:3, text: 'Date'}, { id:4, text: 'Email'}, { id:5, text: 'Mobile'}, { id:6, text: 'Multiline'}, { id:7, text: 'Boolean'  }, { id:10, text: 'Provider'}],
      selectedDataType: 1,
      sections: [],
      isEdit: false,
    };
  },
  methods: {
    getItemType(id) {
      const type = this.itemType.find(x => x.id === id)
      return type.text;
    },
    async getVerificationProviders() {
      try {
        const providers = await this.$store.dispatch(GET_VERIFICATION_PROVIDERS);
        for (let key in providers) {
          const provider = {
            id: providers[key],
            name: key,
          };
          this.verificationProviders.push(provider);
        }
      } catch(err) {
        this.$notify({
          type: 'error',
          title: 'Error!',
          text: 'Error getting verification providers. Please contact support@planetverify.com',
        });
      }
    },
    updateprofileItemsList() {
      this.dataLoading = true
      this.$store.dispatch(GET_PROFILE_ITEMS).then(response => {
        this.profileItems = response
        this.totalRows = response.length
        this.dataLoading = false
      }, () => {
        this.$notify({
          type: 'error',
          title: 'Error!',
          text: 'Something went wrong - please contact support@planetverify.com',
        });
        this.dataLoading = false
      })
    },
    addSection() {
      this.sections.push({ id: uuidv4(), name: '', sectionItems: [ { id: uuidv4(), name: '', dataType: 1, ordinal: this.sections.length + 1 } ] });
    },
    addItem(section) {
      section.sectionItems.push({ id: uuidv4(), name: '', dataType: 1, ordinal: section.sectionItems.length + 1 });
    },
    saveProfileItem() {
      if(this.$refs.itemForm.validate()) {
        const newprofileItem = {
          id: this.id,
          itemType: this.selectedItemType,
          dataType: this.selectedDataType,
          name: this.name,
          description: this.description,
          ordinal: this.ordinal,
          verificationProviders: this.selectedVerificationProviders,
          sections: this.sections,
        };
        this.$store.dispatch(ADD_PROFILE_ITEM, newprofileItem).then(() => {
          if (!this.isEdit) {
            this.profileItems.push(newprofileItem)
            this.$notify({
              type: 'success',
              title: 'Success',
              text: 'Profile item added',
            });
          } else {
            var oldValueIndex = this.profileItems.findIndex(x => x.id == newprofileItem.id)
            if (oldValueIndex !== -1) {
              this.$set(this.profileItems, oldValueIndex, newprofileItem)
            }
            this.$notify({
              type: 'success',
              title: 'Success',
              text: 'Profile item saved',
            });
          }
        }, () => {
          this.$notify({
            type: 'error',
            title: 'Error!',
            text: 'Something went wrong - please contact support@planetverify.com',
          });
        })
        this.handleSubmit();
      }
    },
    editProfileItem(item) {

      console.log(item)

      this.isEdit = true;
      this.id = item.id;
      this.selectedItemType = item.itemType;
      this.selectedDataType = item.dataType;
      this.name = item.name;
      this.description = item.description;
      this.ordinal = item.ordinal;
      this.selectedVerificationProviders = item.verificationProviders;
      this.sections = item.sections;
      this.modalTitle = 'Edit Profile Item';
      this.dialog = true;
    },
    addProfileItem() {
      this.isEdit = false;
      this.id = uuidv4();
      this.modalTitle = 'New Profile Item';
      this.selectedItemType = 1;
      this.selectedDataType = 1;
      this.name = '';
      this.description = '';
      this.ordinal = 0
      this.sections = [];
      this.dialog = true;
    },
    handleSubmit() {
      this.id = '';
      this.selectedItemType = 1;
      this.selectedDataType = 1;
      this.name = '';
      this.description = '';
      this.ordinal = 0
      this.sections = [];
      this.dialog = false;
    },
  },
  mounted() {
    this.updateprofileItemsList();
    this.getVerificationProviders();
  },
}
</script>
